import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  icon: {
    color: '#FFFFFF',
    height: 40,
    width: 156,
    marginTop: 25,
  },
  box: {
    display: 'flex',
  },
  appBar: {
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.12)',
  },
  appToolbar: {
    justifyContent: 'space-between',
    [theme.breakpoints.up('md')]: {
      marginLeft: 'auto',
    },
  },
  navDrawer: {
    '.MuiPaper-root': {
      position: 'relative',
      whiteSpace: 'nowrap',
      boxSizing: 'border-box',
      backgroundColor: theme.palette.custom.primary2,
      width: 'auto',
      display: 'block',
      [theme.breakpoints.up('md')]: {
        backgroundImage: 'url("/navbar.svg")',
        backgroundPosition: 'bottom',
        backgroundRepeat: 'no-repeat',
        content: "''",
        width: 266,
      },
    },
  },
  container: {
    flexGrow: 1,
    height: 'calc(100vh - 64px)',
    marginTop: 64,
    overflow: 'auto',
    [theme.breakpoints.down('sm')]: {
      marginTop: 48,
    },
  },
  toolBar: {
    justifyContent: 'space-between',
  },
  closeIcon: {
    fill: '#FFFFFF',
  },
  menuIcon: {
    marginLeft: 4,
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  userListContainer: {
    backgroundColor: '#FAFAFB',
    margin: 25,
    padding: '2px 15px 15px',
    borderRadius: 6,
  },
  lessonButtonContainer: {
    marginTop: 32,
  },
  modal: {
    overflow: 'scroll',
  },
  modalContainer: {
    backgroundColor: '#FFFFFF',
    padding: 1,
    maxWidth: '700px',
    margin: '100px auto 0',
    borderRadius: 16,
    [theme.breakpoints.down('md')]: {
      margin: 0,
    },
  },
}));

export default useStyles;
